<template>

    <SubHeader title="Fiche service" :breads="[{ name: 'Fichier Service' }]" :action="{}" />
    <div class="row">
        <div class="col-md-12">
            <form @submit.prevent="handleSubmit(item)">
                

                <div class="row">
                    <div class="col-md-6">
                        <div class="card">

                            <div class="card-header card-header-content-md-between">
                                <h3 class="card-header-title">Détails</h3>
                                <small class="text-muted">Saisie des informations</small>
                            </div>
                            <div class="card-body">
                                <div class="mb-3">
                                    <label class="form-label" for="label">Libellé</label>
                                    <input type="text" required name="label" id="label" v-model="item.label" class="form-control" placeholder="Service"
                                        value="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <button type="submit" class="btn btn-primary">Modifier</button>&nbsp;
                                <button type="button" class="btn btn-danger" @click="this.$router.back()">Annuler</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
    name: "AdminConfigShowService",
    components: {
        SubHeader
    },
    data(){
        return {
            data:{}
        }
    },
    computed: {
        ...mapFields("service/show", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            showMessage: "showMessage",
            message: "message",
            item: "item",

        }),
        ...mapFields("service/update", {
            isUpdated: "isUpdated"
        }),
    },
    methods:{
        ...mapActions({
            handleSubmit:"service/update/update",
            reset:"service/update/resetData",
            resetShow:"service/show/resetData",
            getService:"service/show/getOne",
        })
    },
    watch:{
        isUpdated(val){
            if(val){
                this.$router.push({name:"AdminConfigService"})
            }
        }
    },

    unmounted(){
        this.resetShow()
        this.reset()
    },
    mounted(){
        this.getService(this.$route.params.id ?? null);
    }
}
</script>
